import { motion } from "framer-motion"
import { Zap, MapPin, Lock, Gift } from "lucide-react"

interface FeaturesSectionProps {
  t: Record<string, any>
}

export function FeaturesSection({ t }: FeaturesSectionProps) {
  const features = [
    {
      title: t?.features?.quickBooking || "Quick Booking",
      description: t?.features?.quickBookingDesc || "Book in seconds with our intuitive interface",
      icon: Zap,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: t?.features?.liveTracking || "Live Tracking",
      description: t?.features?.liveTrackingDesc || "Track your ride in real-time",
      icon: MapPin,
      color: "from-emerald-500 to-emerald-600",
    },
    {
      title: t?.features?.securePayment || "Secure Payment",
      description: t?.features?.securePaymentDesc || "Multiple payment options with bank-level security",
      icon: Lock,
      color: "from-purple-500 to-purple-600",
    },
    {
      title: t?.features?.rewards || "Rewards Program",
      description: t?.features?.rewardsDesc || "Earn points on every ride",
      icon: Gift,
      color: "from-orange-500 to-orange-600",
    },
  ]

  return (
    <section id="features" className="py-20 px-4 bg-black">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-white mb-4">{t?.features?.title || "Features"}</h2>
          <p className="text-xl text-gray-300">Everything you need for a seamless experience</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -4 }}
                className="p-6 rounded-lg bg-white/5 border border-white/10 hover:border-white/20 transition-all duration-300 group"
              >
                <div className={`inline-flex p-3 rounded-lg bg-gradient-to-r ${feature.color} mb-4`}>
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">{feature.title}</h3>
                <p className="text-gray-400">{feature.description}</p>
              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
